import { Component, OnInit } from '@angular/core';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { AuthService, alertsAnimation } from 'src/app/auth.service';
import { ThemingService, ShopTheming } from 'src/app/theming.service';
import { Router } from '@angular/router';
import { SettingsService } from 'src/app/settings.service';
import { LambdaService } from 'src/app/lambda.service';
import { EmailTemplateEditorComponent } from '../email-template-editor/email-template-editor.component';

@Component({
  selector: 'app-add-staff',
  templateUrl: './add-staff.component.html',
  styleUrls: ['./add-staff.component.scss'],
  animations: [ alertsAnimation ]
})
export class AddStaffComponent implements OnInit {
  public shopTheme: ShopTheming[] = [];
  public permissionsFormGroup!: FormGroup;

  isException: boolean = false;
  exceptionMessage: String = '';
  isPasswordVisible: boolean = false;
  roles: any = [];
  loadModal:boolean = false;

  staffMembers: number = 0;
  staffMaxMembers: number = 2;

  public signUpForm!: FormGroup;
  public newUserForm!: FormGroup;
  user_role: string = 'User';
  configAcces: boolean = false;

  newUserEmail = "";
  isNewUser = true;
  userUpdated: any = {};
  formStep = 1;
  userCreated = false;

  constructor(
    private fb: FormBuilder,
    private authService: AuthService,
    private router: Router,
    private themingService: ThemingService,
    private settingsService: SettingsService,
    private lambdaService: LambdaService
  ) {
      this.shopTheme = this.themingService.shopTheming;

    this.newUserForm = this.fb.group({
      "userEmail": ['', [
        Validators.required,
        Validators.email,
        Validators.pattern('^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+$')
      ]]
    })

    /* Creating a form group with three controls. */
    this.signUpForm = this.fb.group({
      "givenName": ['',[
        Validators.required,
        Validators.minLength(3),
        Validators.pattern('[a-zA-ZÀ-ÿ][a-zA-ZÀ-ÿ ]+'),
      ]],
      "familyName": ['',[
          Validators.required,
          Validators.minLength(3),
          Validators.pattern('[a-zA-ZÀ-ÿ][a-zA-ZÀ-ÿ ]+'),
      ]],
      // "givenEmail": ['', [
      //   Validators.required,
      //   Validators.email,
      //   Validators.pattern('^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+$')
      // ]],
      "givenPassword": ['', [
        Validators.required,
        Validators.minLength(8),
        Validators.pattern('^(?=.*[A-Z])(?=.*[a-z])(?=.*\\d)(?=.*[^A-Za-z0-9]).{8,}$'),
      ]],
      permissions: this.fb.group({
        home: [false],
        sales: [false],
        cashRegisters: [false],
        products: [false],
        giftCards: [false],
        coupons: [false],
        clients: [false],
        calendar: [false],
        config: [false],
        //config permissions
        generalInfo:[false],
        userRoles:[false],
        categories:[false],
        collections:[false],
        supliers:[false],
        shopPoints:[false],
        paymentMethods:[false],
        themingService:[false],
        faqs:[false],
        exportClients:[false],
        pos:[false],
        pages:[false],
        analytics:[false],
        emailTemplate: [false],
        chatApp: [false]
      })
    });
    this.permissionsFormGroup = this.signUpForm.get('permissions') as FormGroup;
  }

  get signUpFormValidation() {
    return this.signUpForm.controls;
  }

  get newUserFormValidation() {
    return this.newUserForm.controls;
  }

  ngOnInit(): void {
    this.signUpForm.get('permissions.config')?.valueChanges.subscribe((value: boolean) => {
      this.configAcces = value;
    });
    this.authService.listGroups().then((groupsData: any)=>{
      this.roles = groupsData.filter((data:any) => data.GroupName != 'Owner');
    }).then(()=>{
      let currentPlan = this.shopTheme[0].shopSubscription;
      this.staffMaxMembers = currentPlan.shopMaxUsers;
      //let currentPlan = this.shopTheme[0].currentContract;
      // switch (currentPlan) {
      //   case 'Basic':
      //       this.staffMaxMembers = 2;
      //       break;
      //     case 'Advanced':
      //       this.staffMaxMembers = 5;
      //       break;
      //     case 'Corporate':
      //       this.staffMaxMembers = 15;
      //       break;
      //     default:
      //       this.staffMaxMembers = 2;
      //       break;
      //   }
    }).then(()=>{
      this.loadMaxMembers()
    });
  }

  verifyNewUser(){
    //get users
    this.newUserEmail = this.newUserForm.value.userEmail;
    this.authService.getUsers().then((usersData: any)=>{
      let user = usersData.filter((user: any) => user.email == this.newUserEmail);
      //let user = usersData.Users.find((user: any) => user.Email == email);
      if(user.length > 0){
        if(user[0].shop_access.split(',').includes(this.themingService.shopTheming[0].shopId.toString())){
          this.exceptionMessage = "Este usuario ya existe.";
        }else{
          this.userUpdated = user[0];
          this.userUpdated.shop_access = (this.userUpdated.shop_access !== "" ? `${this.userUpdated.shop_access},${this.themingService.shopTheming[0].shopId.toString()}` : this.themingService.shopTheming[0].shopId.toString());
          this.formStep = 3;
        }
      } else{
        this.formStep = 2;
      }
    })
  }

  addShopToExistUser(){
    this.authService.updateUser(
      this.userUpdated.Username,
      this.userUpdated.given_name,
      this.userUpdated.family_name,
      this.userUpdated.phone_number,
      this.userUpdated.permissions,
      this.userUpdated.shop_access
    ).then(()=>{
      this.userCreated = true;
    }).catch((error)=>{
      console.log(error);
      this.exceptionMessage = error.message;
    });
  }

  loadMaxMembers(){
    this.authService.getUsers().then((usersData: any)=>{
      usersData.forEach((user: any) => {
        const userIds = user.shop_access.split(',').map((id: any) => id.trim());
        const shopIdStr = this.themingService.shopTheming[0].shopId.toString();
        if (userIds.includes(shopIdStr)) {
          if(user.user_role != 'Owner'){
            this.staffMembers++;
          }
        }
      });
    })
  }

  getPermissionsObject() {
    return this.signUpForm.get('permissions')?.value;
  }

 onSignUp(){
  if (this.staffMembers < this.staffMaxMembers) {
    const permissions = JSON.stringify(this.getPermissionsObject());
    const posEnabled = this.signUpForm.get('permissions.pos')?.value;

    this.authService.createUserAdmin(
      this.signUpForm.value.givenName,
      this.signUpForm.value.familyName,
      this.newUserEmail,
      this.user_role,
      this.signUpForm.value.givenPassword,
      permissions,
      this.themingService.shopTheming[0].shopId.toString()
    ).then(() => {
      this.authService.adminAddUserToGroup(this.newUserEmail, this.user_role);
      const firstName = this.signUpForm.value.givenName;
      const lastName = this.signUpForm.value.familyName;
      const email = this.newUserEmail;

      this.userCreated = true;

      if (posEnabled) {
        this.lambdaService.createVendor(
          this.themingService.shopId,
          firstName,
          lastName,
          email
        ).then(() => {
            this.isException = false;
            this.loadMaxMembers();
            this.signUpForm.reset();
            this.newUserForm.reset();
            this.loadModal = true;
          }).catch((error) => {
            this.isException = true;
            this.exceptionMessage = error.message;
          });
      } else {
        this.isException = false;
        this.loadMaxMembers();
        this.signUpForm.reset();
        this.newUserForm.reset();
        this.loadModal = true;
      }
    }).catch((error: any) => {
      console.log(error);
      this.isException = true;
      this.exceptionMessage = this.authService.handleErrors(error.message + 'backoffice', "");
    })
  } else {
    this.isException = true;
    this.exceptionMessage = 'Haz alcanzado el límite de usuarios permitidos para tu plan.';
  }
}

  onCreateAnotherUser(){
    this.signUpForm.reset();
    this.loadModal = false;
  }

  onClose(){
    this.router.navigate(['/users']);
  }

  /**
   * The function calls the setListingUsers() function in the settingsService
   */
  setListingUsers(): void {
    this.settingsService.setListingUsers();
  }
}
